<template>
<div class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header p-2">
        <h6 class="modal-title" v-if='selectedPlugin.plugin_name'>{{selectedPlugin.pluginName}}</h6>
        <button class="close text-white" data-dismiss="modal" aria-label="Close" v-on:click="close">
          <span aria-hidden="true"><cancel-icon class="close-icon" style="height: 30px !important;
    width: 30px !important;
    color: #fff;"></cancel-icon></span>
        </button>
      </div>
      <div class="modal-body p-0">
            <div>
                <iframe v-if="selectedPlugin.id" id="show_plugin_in_overflowmenu" ref="iframeOverflowmenu" style="width:100%;height:100%;" frameBorder=0></iframe>
            </div>
      </div>
      <div class="modal-footer p-0 primary-btn-style">
       
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {mapMutations} from "vuex"
import cancelIcon from "../core/InlineCancelField.vue"

export default {
    props:["selectedPlugin"],
    data(){
      return{
        iframeController:null
      }
    },
    components:{
        'cancel-icon':cancelIcon
    },
    methods:{
        close(){
            this.$emit("close")
        },
        load(plugin){
            this.loadExternalPluginOverflowMenuDialogUI({id: this.selectedPlugin.id, pluginName: plugin, tagId: "show_plugin_in_overflowmenu"})// eslint-disable-line no-undef
            this.iframeController = this.$refs.iframeOverflowmenu.contentWindow
        },
        ...mapMutations("registry",["loadExternalPluginOverflowMenuDialogUI"]),
    },
    mounted() {
        console.log(this.selectedPlugin)
        setTimeout(() => this.load( this.selectedPlugin.pluginName), 100);
    }
}
</script>

<style scoped lang="scss">
$header-background: #1a1a1a;
$border-color: 1px solid #1a1a1a;
$background: #121212;
$bg-color-on-hover: #141414;
$body-bg-color: #0d0d0d;
$dull-text-color: #757575;
$options-text-color: #9c9c9c;
$text-color: #eee;
$table-row-border: none;
$active-blue : #007bff;
$modal-border:1px solid #202020;
$modal-background: #121212;
$header-color:#9e9e9e;
.modal-dialog {
    width: 100vw;
    height: 100vh;
    max-width:100%;
    margin: 0;
    padding: 0;
  }
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $body-bg-color !important;
    border: $modal-border;
    .modal-body{
      background: $modal-background;
      height:400px;
      overflow:auto;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}


.modal-header,.modal-footer{
    border: none !important;
    background: $header-background;
    .modal-title{
      color:$header-color;
    }
}


.modal-footer{
    justify-content: start;
}

.close-icon:hover{
  background: #373737;
  border-radius: 20px;
}

</style>


